import * as Sentry from '@sentry/electron/renderer'
import { createSnapshotConsumer } from '@highlight/ipc'
import { useSnapshotConsumer } from '@highlight/ipc/react'
import { DOCK_SNAPSHOT_TOPIC, EMPTY_DOCK_SNAPSHOT, type DockSnapshot } from '@shared/dock-snapshot'

const dockSnapshotConsumer = createSnapshotConsumer<DockSnapshot>({
  topic: DOCK_SNAPSHOT_TOPIC,
  initialSnapshot: EMPTY_DOCK_SNAPSHOT,
  onError: (error) => {
    Sentry.captureException(error, { tags: { module: 'dock-snapshot' } })
  },
})

export function useDockSnapshot(): DockSnapshot {
  return useSnapshotConsumer(dockSnapshotConsumer)
}
